import React from 'react';
import { withRouter } from 'react-router-dom';
import { NotFoundWrapper, NotFound404 } from './elements';

import Emoji from 'assets/images/emoji.png';
import Button from 'components/button';
import MetaHelmet from 'components/MetaHelmet';

function NotFoundPage(props) {
  const { history, match } = props;
  function handleBackToHome() {
    history.push('/');
    window.location.reload();
  }

  function handleStreamError() {
    return (
      <>
        <h3 style={{ marginBottom: 0, marginTop: 28 }}>
          OOPS! THIS STREAM IS NO LONGER AVAILABLE
        </h3>
      </>
    );
  }

  return (
    <>
      <MetaHelmet />
      <NotFoundWrapper>
        <NotFound404 image={Emoji} />
        {props.streamIsActive === false ? (
          handleStreamError()
        ) : (
          <>
            <h1>404</h1>
            <h3>
              Oops!{' '}
              {match.path.includes('event')
                ? `Event`
                : match.path.includes('album')
                ? `Album`
                : `Page`}{' '}
              Cannot Be Found
            </h3>
          </>
        )}
        <Button
          width="200px"
          color="yellow"
          onClick={handleBackToHome}
          style={{ marginTop: 28 }}
        >
          Go Back Home
        </Button>
      </NotFoundWrapper>
    </>
  );
}

export default withRouter(NotFoundPage);
